/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `OPEN` - Open * `ARCHIVED` - Archived * `CANCELLED` - Cancelled * `LOCKED` - Locked * `LOCKED_CONFIRMATION` - Confirmation Locked * `LOCKED_DATA_REQUEST` - Data Request Locked
 * @export
 * @enum {string}
 */
export enum BookingStatusEnum {
    Open = 'OPEN',
    Archived = 'ARCHIVED',
    Cancelled = 'CANCELLED',
    Locked = 'LOCKED',
    LockedConfirmation = 'LOCKED_CONFIRMATION',
    LockedDataRequest = 'LOCKED_DATA_REQUEST'
}



